// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";

function fetchUnloadedData(data, apiRequest) {
  switch (data.TAG | 0) {
    case /* Live */1 :
        return ;
    case /* Loading */0 :
    case /* Error */2 :
        return Curry._1(apiRequest, undefined);
    
  }
}

export {
  fetchUnloadedData ,
  
}
/* No side effect */
